import React, { useEffect, useState } from 'react';
import Form from './Form';
import ReliabilityDetailsModel from '../model/ReliabilityDetailsModel';
import UserModel from '../model/UserModel';
import { getMaterialsFromId, reliabilityColor } from '../utils/utils';
import Countries from './Countries';
import { getMaterials } from '../controller/ecobalyseController';
import CheckMark from '../icon/CheckMark';
import AlmostEqual from '../icon/AlmostEqual';
import CrossSign from '../icon/CrossSign';
import ProductImpact from './ProductImpact';
import DetailedProduct from '../model/DetailedProductModel';

interface DetailsContentProps {
  user: UserModel | undefined;
  id: string;
  name: string;
  id_product: string;
  site: string;
  reliability: number;
  color: string;
  category: string;
  weight: number;
  materials: any;
  country_fabric: string;
  country_dyeing: string;
  country_making: string;
  category_predicted: boolean;
  reliability_details: ReliabilityDetailsModel;
  sizes: string[];
  product: DetailedProduct; 
}

const DetailsContent: React.FC<DetailsContentProps> = (props) => {
  const [fullMaterials, setFullMaterials] = useState<any[]>([]);

  useEffect(() => {
    const reliabilityElement = document.getElementById('reliabilityContent');
    if (reliabilityElement) {
      reliabilityElement.style.width = `${props.reliability * 100}%`;
    }
    getMaterials().then((materials) => {
      setFullMaterials([...materials, { id: '', name: '' }]);
    });
  }, [props.reliability]);

  return (
    <div>
      <div className="flex flex-col gap-4">
        <Countries
          country_fabric={props.country_fabric}
          country_dyeing={props.country_dyeing}
          country_making={props.country_making}
          reliability_details={props.reliability_details}
        />
        <div className="bg-blackOverlay dark:bg-whiteOverlay md:rounded-3xl rounded-2xl md:p-6 p-4 group flex flex-col gap-3">
          <p className="font-medium text-center md:text-xl xshort:text-sm text-sm">
            {Object.keys(props.materials).map((mat, index) => {
              return fullMaterials.length > 0
                ? getMaterialsFromId(mat, fullMaterials) +
                    ' : ' +
                    Math.round(props.materials[mat] * 100) +
                    '%' +
                    (index !== Object.keys(props.materials).length - 1 ? ', ' : '')
                : '';
            })}
          </p>
        </div>
        <div className="bg-blackOverlay dark:bg-whiteOverlay md:rounded-3xl rounded-2xl md:p-6 p-4 group flex flex-col gap-3">
          <ProductImpact product={props.product}/>
        </div>
        <div className="bg-blackOverlay dark:bg-whiteOverlay md:rounded-3xl rounded-2xl md:p-6 p-4 group flex flex-col gap-3">
          <div className="flex items-end justify-between">
            <p className="md:text-lg xshort:text-sm text-sm">
              Informations transmises par l'entreprise :
            </p>
            <p className="md:text-lg xshort:text-sm text-sm">
              {Math.round(props.reliability * 100)}%
            </p>
          </div>
          <div className="h-2 w-full bg-gray rounded-full">
            <div
              id="reliabilityContent"
              className={`h-2 rounded-full ${reliabilityColor(props.reliability * 100)}`}
            ></div>
          </div>
        </div>
      </div>

      <div className="text-base my-8">
        {/* Section commentée
        <div className="flex flex-col md:flex-row items-center gap-3 justify-around my-6">
          <div className="flex flex-row gap-2 items-center space-x-2">
            <CheckMark />
            <p>Donnée fiable</p>
          </div>
          <div className="flex flex-row gap-2 items-center">
            <AlmostEqual />
            <p>Donnée peu fiable</p>
          </div>
          <div className="flex flex-row gap-2 items-center space-x-2">
            <CrossSign />
            <p>Donnée non transmise</p>
          </div>
        </div>
        */}
      </div>

      <Form
        user={props.user}
        id={props.id}
        name={props.name}
        id_product={props.id_product}
        site={props.site}
        color={props.color}
        category={props.category}
        sizes={props.sizes}
        weight={props.weight}
        materials={props.materials}
        country_fabric={props.country_fabric}
        country_dyeing={props.country_dyeing}
        country_making={props.country_making}
        category_predicted={props.category_predicted}
        reliability_details={props.reliability_details}
      />
    </div>
  );
};

export default DetailsContent;
